import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addCartItems, updateCartItem, removeCartItem } from '../../store/cartItems';
import { AddShoppingCart, Email, ErrorOutline, FacebookRounded, RemoveShoppingCart, Security, Star, StarBorder, StarHalf, Twitter, VolunteerActivism, WhatsApp } from "@mui/icons-material";
import { setViewImages } from '../../store/viewImages';
import { setToStore, num2Thousand, imgCheck, isMobile } from '../../utils/fn';
import { Button, IconButton } from "@mui/material";
import icons from '../../utils/icons.json';
import _ from 'lodash';
import constants from '../../utils/constants.json';
import img from '../../assets/product-placeholder.png';
import { setAlert } from '../../store/alert';
import Sharemini from '../../components/sharemini';
import { useLocation } from 'react-router-dom';
import Loading from '../../components/Loading';

function ProductView({ product, loading }) {
	const dispatch = useDispatch();


	const cartItems = useSelector((state) => state.cartItems.data);
	const webSettings = useSelector((state) => state.webSettings.data);

	const [thumbnail, setThumbnail] = useState(img);
	const [quantity, setQuantity] = useState(1);
	const [imagePosition, setImagePosition] = useState(0);
	const [isCartItem, setIsCartItem] = useState(false);


	useEffect(() => {
		setQuantity(parseInt(product.quantity) || 1);
	}, [product]);

	useEffect(() => {
		Array.isArray(product.src) && imgCheck(product.src[imagePosition], img).then((src) => setThumbnail(src));
	}, [product, imagePosition]);

	useEffect(() => {
		setToStore(constants.CART_ITEMS, cartItems);
		let found = false;
		cartItems.forEach((item, index) => {
			if (item.item_code === product.item_code) {
				found = true;
				setQuantity(item.quantity);
			}
		});
		setIsCartItem(found);
	}, [cartItems]);

	function updateQuantity(quant) {
		setQuantity(quant);
		if (isCartItem) {
			dispatch(updateCartItem({ ...product, quantity: quant }));
		}
	}

	function nextImage() {
		if (imagePosition < product.src?.length - 1) {
			setImagePosition((prev) => prev + 1);
		}
	}

	function previousImage() {
		setImagePosition((state) => (state > 0 ? state - 1 : 0));
	}

	function viewPreview(e) {
		dispatch(setViewImages(product.src));
	}

	function addToCart(e) {
		dispatch(addCartItems([{ ...product, quantity }]));
		dispatch(setAlert('Item added to Cart'));
	}

	function removeFromCart() {
		dispatch(removeCartItem(product.item_code));

		dispatch(setAlert({ type: 'warning', message: 'Item removed from Cart' }));
	}


	const productprice = product?.promotion_price > 0 ? product.promotion_price : product.price
	const url = `${window.location.host}/product/${product.itemURL}`

	return (
		<div className="product-preview sections">
			{loading && <Loading />}
			<div onClick={viewPreview} className="image" style={{ backgroundImage: `url(${thumbnail})` }}>
				<div className="thumbnail">
					{product.src?.map((url, index) => (
						<section key={url + index} className={'each' + (imagePosition === index ? ' active' : '')} style={{ backgroundImage: `url(${url || img})` }}></section>
					))}<br />
				</div>
				{imagePosition > 0 && <button className="btn prev" onClick={previousImage} dangerouslySetInnerHTML={{ __html: icons.angle_left }} />}
				{imagePosition < product.src?.length - 1 && <button className="btn next" onClick={nextImage} dangerouslySetInnerHTML={{ __html: icons.angle_right }} />}
			</div>
			<div className="details">
				<div className="top-section">
					<h3 className="name">{_.startCase(product?.item_name)}</h3>
					<p className="short-name">Brand: {product?.brandName} | {product.group_name} </p>
					{/* {_.startCase(product.shortItemName)} */}
					{product?.promotion_price > 0 ?
						<h1 className="price">
							{webSettings.CURRENCY} {product.promotion_price}
							<div className='discountpriceview'>{webSettings.CURRENCY} {parseFloat(product.price)?.toFixed(2)}</div>
						</h1> :
						<h1 className="price">
							{webSettings.CURRENCY} {productprice}
						</h1>
					}
				</div>
				<div className="bottom-section">
					<div className="infos">
						<div className="view-quantity">
							<h4>Quantity</h4>
							<div className="btn-group">
								<button type="button" onClick={() => updateQuantity(quantity > 1 ? quantity - 1 : 1)} dangerouslySetInnerHTML={{ __html: icons.minus }}></button>
								<input value={quantity} type="number" min="1" step="1" onInput={(e) => updateQuantity(parseInt(e.target.value) || 1)} />
								<button type="button" onClick={() => updateQuantity(quantity + 1)} dangerouslySetInnerHTML={{ __html: icons.plus }}></button>
							</div>
						</div>
						<div className="view-amount">
							<h3>
								{webSettings.CURRENCY} {productprice}
							</h3>
						</div>
					</div>
					<Ratings product={product} />
					<div className="sub-info">
						{!isCartItem && (
							<Button sx={{ fontSize: 13 }} onClick={addToCart} variant="contained" startIcon={<AddShoppingCart sx={{ fontSize: 20 }} />}> ADD TO CART</Button>
						)}
						{isCartItem && (
							<Button sx={{ fontSize: 13 }} onClick={removeFromCart} variant="outlined" startIcon={<RemoveShoppingCart sx={{ fontSize: 20 }} />}> REMOVE FROM CART</Button>
						)}
						{
							isMobile() ?
								<h4>Total: {webSettings.CURRENCY} {num2Thousand((parseFloat(productprice) * quantity).toFixed(2))}</h4> :
								<h2>Total: {webSettings.CURRENCY} {num2Thousand((parseFloat(productprice) * quantity).toFixed(2))}</h2>
						}
					</div>
					SHARE THIS PRODUCT
					<Sharemini link={url} name={product.item_name} />
				</div>
			</div>
		</div>
	);
}

export default React.memo(ProductView);


const Ratings = ({ product }) => {
	const average = (parseInt(product.ratingTotal) / product?.item_ratings?.length)?.toString().substring(0, 3);

	return (
		<div className="ratings">
			<Stars rating={average == 'NaN' ? 3.5 : average} />
			{product.item_ratings?.length > 0 && `(${product.item_ratings?.length} Ratings)`}
		</div>
	)
}

const Stars = ({ rating }) => {
	// Calculate the number of full stars and half stars
	const fullStars = Math.floor(rating);
	const hasHalfStar = rating % 1 !== 0;

	// Create an array to store the star components
	const starsArray = [];

	// Add full stars
	for (let i = 0; i < fullStars; i++) {
		starsArray.push(<Star key={i} />);
	}

	// Add half star if necessary
	if (hasHalfStar) {
		starsArray.push(<StarHalf key="half" />);
	}

	// Fill the rest with empty stars
	const totalStars = 5;
	while (starsArray.length < totalStars) {
		starsArray.push(<StarBorder key={starsArray.length} />);
	}

	return <div className="productstars">{starsArray}</div>;
};